function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M336 131c1 42 0 50-1 49-2-3-15-10-24-13-16-5-14-5-122-5H87l-1 24v24h98l-2 4c-3 4-8 13-10 20-6 16-5 15-5 124v102h48v-98l11 6 22 9 10 2h103l104 1-1-24v-25h-97l6-12c6-13 9-23 11-38V82h-48v50zm-47 81c10 2 18 7 25 13a56 56 0 0121 45 60 60 0 01-94 50 61 61 0 01-25-63c4-17 16-32 31-40 13-7 28-9 42-5z",
  fill: "#0344b9"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 275,
  cy: 431.7,
  r: 40.7
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 275,
  cy: 508,
  r: 20.8
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 436.3,
  cy: 270.3,
  r: 40.7
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 512.6,
  cy: 270.3,
  r: 20.8
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 112.7,
  cy: 270.8,
  r: 40.7
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 36.4,
  cy: 270.8,
  r: 20.8
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 275.3,
  cy: 109.1,
  r: 40.7
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  fill: "#da1f48",
  cx: 275.3,
  cy: 32.8,
  r: 20.8
});

var SvgPinpointLogoSm = function SvgPinpointLogoSm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 560",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinpointLogoSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinpoint_logo_sm.649ebf14.svg";
export { ForwardRef as ReactComponent };